import { type PriceTrackInfo } from './types';

import {
    PriceTrackApiApiPriceTrackAddPost,
    PriceTrackApiApiPriceTrackSetAlertPost,
    PriceTrackApiApiPriceTrackTrackListGet,
    type PriceTrackListResponse,
    type SetAlertRequest,
} from '@clients/PricetrackApi';

class PriceTrackStore {
    //#region state
    priceTrackInfo: PriceTrackInfo | null = null;
    priceTrackList: PriceTrackListResponse[] = [];
    loading = true;
    trainPreSellAlerts: string[] = [];
    //#endregion

    /**
     * get vehicle name of current tracking
     *
     * @readonly
     * @type {string}
     * @memberof PriceTrackStore
     */
    get vehicleName(): string {
        if (this.priceTrackInfo && !this.priceTrackInfo.serviceId) {
            return 'مسیر';
        }
        switch (this.priceTrackInfo!.serviceType) {
            case 0:
                return 'پرواز';
            case 1:
                return 'قطار';
            case 2:
                return 'اتوبوس';
            default:
                return '';
        }
    }

    /**
     * ACTION - Adds a new price track for selected price
     *
     * @memberof PriceTrackStore
     */
    addPriceTrack() {
        const { userInfo } = useAuthStore();
        return PriceTrackApiApiPriceTrackAddPost({
            addPriceTrackRequest: {
                ...this.priceTrackInfo,
                departureTime: this.priceTrackInfo?.departureDateTime
                    ? formatISO(this.priceTrackInfo.departureDateTime)
                    : null,
                arrivalTime: this.priceTrackInfo?.arrivalDateTime
                    ? formatISO(this.priceTrackInfo.arrivalDateTime)
                    : null,
                decreasePercent: null,
                phoneNumber: userInfo?.mobile,
            },
        });
    }

    addPreSellAlert(key: string) {
        const analyticsStore = useAnalyticsStore();
        analyticsStore.trackAll('trainTracking');
        const prevList =
            LocalStorageUtils.getItem<Array<any>>('train-presell-notifies') ??
            [];
        const expire = new Date();
        expire.setDate(new Date().getDate() + 7);
        const newList = [...prevList];
        if (!prevList.includes(key)) {
            newList.push(key);
            this.trainPreSellAlerts.push(key);
        }
        LocalStorageUtils.setItem('train-presell-notifies', newList, expire);
    }

    removePreSellAlert(key: string) {
        const prevList =
            LocalStorageUtils.getItem<Array<any>>('train-presell-notifies') ??
            [];
        const expire = new Date();
        expire.setDate(new Date().getDate() + 7);
        const newList = prevList.filter(item => item !== key);
        LocalStorageUtils.setItem('train-presell-notifies', newList, expire);
        this.trainPreSellAlerts = newList;
    }

    /**
     * ACTION - Sets the price track for user
     *
     * @param {Object} body
     * @memberof PriceTrackStore
     */
    setPriceTrackAlert(body: SetAlertRequest) {
        return PriceTrackApiApiPriceTrackSetAlertPost({
            setAlertRequest: body,
        });
    }

    /**
     * ACTION - Loads the price track list from the server
     *
     * @memberof PriceTrackStore
     */
    async loadPriceTracks() {
        try {
            this.trainPreSellAlerts =
                LocalStorageUtils.getItem<Array<any>>(
                    'train-presell-notifies'
                ) ?? [];
            this.loading = true;
            const { data } = await PriceTrackApiApiPriceTrackTrackListGet();
            this.priceTrackList = data;
        } catch (error) {
            reportException(error);
        } finally {
            this.loading = false;
        }
    }
}

export const { use: usePriceTrackStore } = defineClassStore(
    'priceTrack',
    () => new PriceTrackStore()
);
